/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".add-spray-btn[_ngcontent-%COMP%]{margin-bottom:1em;margin-top:1.2em}.mt-7[_ngcontent-%COMP%]{margin-top:.7em}.top-horizontal[_ngcontent-%COMP%]{margin-right:0!important;margin-left:0!important}.field-width[_ngcontent-%COMP%]{width:9.5em!important}.number-width[_ngcontent-%COMP%]{width:6em!important}.trade-name-width[_ngcontent-%COMP%]{width:13em!important}.flex-row[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.x-label[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study-form/spray-booth-study-form.component.css.shim.ngstyle.js.pre-build-optimizer.js